import { type State, configurePageLayout, pageLayoutState } from '@klausapp/state/page-layout'
import { valtioBridge } from '@/utils/valtioBridge'
import { updateUserSetting } from '@/api/user-settings'
import { session } from './useSession'
import { screens } from './useBreakpoints'

// Layout state + behavior live in @klausapp/state/page-layout so every consumer
// shares one layout. Vue side: wire in the app bits (settings persistence + `lg`
// breakpoint) and expose the state as a reactive `layoutState` for the SFCs.

configurePageLayout({
  getPersistedLayouts: () => session.user?.settings.pageLayout,
  persist: async (layouts) => {
    await updateUserSetting('pageLayout', layouts)
    session.user.settings.pageLayout = layouts
  },
  screenLg: screens.lg,
})

// Vue reactivity bridge over the framework-agnostic state — read through this,
// write to the state directly. See valtioBridge for the mechanics.
export const layoutState = valtioBridge(pageLayoutState)

export type { State }
export {
  resetLayout,
  sidebarResizer,
  handleContentSidebarResize,
  handleLeftSidebarResize,
  handleRightSidebarResize,
  setLayoutState,
  togglePageNav,
} from '@klausapp/state/page-layout'
